export default __webpack_public_path__ + "static/media/banner3.5ce1c8b9.jpg";